/**
 * PocketBase Configuration
 * 
 * This file contains the configuration for connecting to the PocketBase backend.
 * The URL can be overridden using the VITE_POCKETBASE_URL environment variable.
 */

export const POCKETBASE_URL = import.meta.env.VITE_POCKETBASE_URL || 'http://127.0.0.1:8090';

export const COLLECTION_NAME = 'videogames';
